// Copyright (c) 2017 Deere & Company

import ReimbursementSummaryDetails from '../../reimbursement-summary/details/state-connector';

export default {
    component: ReimbursementSummaryDetails,
    name: 'DETAILS',
    path: 'details'
};



// WEBPACK FOOTER //
// ./src/routes/reimbursement-summary/details.js